import { useDispatch } from "react-redux";
import {
  useCreateLocationMutation,
  useDeleteLocationMutation,
  useSetMainLocationMutation,
  useUpdateLocationMutation,
} from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";

const useSetMainApi = () => {
  const dispatch = useDispatch();
  const [setMain] = useSetMainLocationMutation();

  const send = (body) => {
    dispatch(setLoader(true));
    setMain(body)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        showToast(res?.message ?? "Success", "success");
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    send,
  };
};

export default useSetMainApi;
